;(function () {
  function setHeaderHeight() {
    const header = document.querySelector('.main-header')
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px')
    }
  }
  setHeaderHeight()
  window.addEventListener('resize', window.coolHelperFunctions.debounce(setHeaderHeight, 200))

  // swap the cookiebot dialog's "powered by" logo for the site logo
  function swapCookiebotLogo() {
    // site-logo.php puts .site-logo on the <a> and the <img>, so we have to ask for the img
    const siteLogo = document.querySelector('.main-header--site-logo-container img.site-logo')
    const cybotLogo = document.getElementById('CybotCookiebotDialogPoweredbyImage')
    if (!siteLogo || !cybotLogo) return false
    if (cybotLogo.src === siteLogo.src) return true

    cybotLogo.src = siteLogo.src
    if (siteLogo.srcset) cybotLogo.srcset = siteLogo.srcset
    cybotLogo.alt = siteLogo.alt || cybotLogo.alt
    // cookiebot's own css pins this to 46px, so drop the attrs to keep the logo's aspect
    cybotLogo.removeAttribute('width')
    cybotLogo.removeAttribute('height')
    cybotLogo.style.height = 'auto'
    cybotLogo.style.width = 'auto'
    return true
  }

  // cookiebot injects the dialog from its cdn well after load, so keep looking for ~20s
  let attempts = 0
  function maybeSwapCookiebotLogo() {
    if (swapCookiebotLogo()) return
    attempts += 1
    if (attempts < 40) setTimeout(maybeSwapCookiebotLogo, 500)
  }
  maybeSwapCookiebotLogo()
})();